import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'

import type { AnnotationView } from '@/models/doc'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteHighlightPopup',
  emits: ["confirmDelete"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const highlight = ref<AnnotationView | undefined>(undefined)

function show(_highlight: AnnotationView): void {
  highlight.value = _highlight
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

function confirmDeletion(): void {
  emit('confirmDelete', highlight.value as AnnotationView)
  hide()
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "Delete Highlight"
  }, {
    buttons: _withCtx(() => [
      _createVNode(AppButton, {
        outlined: true,
        big: true,
        onClick: hide
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(AppButton, {
        danger: true,
        big: true,
        onClick: confirmDeletion
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Delete ", -1)
        ]))]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "Are you sure you want to delete this highlight?", -1))
    ]),
    _: 1
  }, 512))
}
}

})